import React from "react";
import PageLinkView from "common/views/pageLink/PageLink.view";
import { Fragment } from "core/components/FragmentProvider";
import constants from "../constants";
import { Article } from "./entities";
import { Classes } from "@blueprintjs/core";
import { Field } from "typegraph";
import { IPageableListQuery } from "common/models/IPageableListQuery";
import { EntityTable } from "core/components/EntityTable";
import CountResult from "panels/organizationParticipant/entities/CountResult";
import { ArticleContributor } from "../articleContributor/entities";

function mapQueryParams(args: any) {
	const params = {};

	Object.entries(args).forEach(([key, value]) => {
		if (value) {
			params[key] = value;
		}
	});

	return { params };
}

class ArticleContributorQuery
	implements IPageableListQuery<ArticleContributor>
{
	@Field({
		entity: ArticleContributor,
		aliasFor: "articleContributor_many",
		params: mapQueryParams,
	})
	public entities: null | ArticleContributor[];

	@Field({
		entity: CountResult,
		aliasFor: "articleContributor_count",
		params: mapQueryParams,
	})
	public count: CountResult;
}

interface IArticleEditFragmentProps {
	article: Article;
	articleContributor: ArticleContributor;
}

export const contributorList: Fragment<IArticleEditFragmentProps> = {
	name: "Contributor",
	component: (props) => {
		const params = {};
		if (props.article && props.article.id) {
			params["articleId"] = props.article.id;
		} else {
			return null;
		}

		return (
			<EntityTable
				pagingQuery={ArticleContributorQuery}
				formClass={ArticleContributor}
				params={params}
				canCreate={false}
				canDelete={false}
				canUpdate={false}
				columns={[
					{
						key: "name",
						label: "Contributor",
						sort: "cont.name",
						renderCell: ({ data }) => (
							<PageLinkView
								viewKey="contributor.link"
								className={Classes.BUTTON}
								preserveParams={false}
								params={{
									[constants.PARAM_CONTRIBUTOR_ID]:
										data.contributor.id,
								}}
							>
								{(data.contributor && data.contributor.name) ||
									null}
							</PageLinkView>
						),
					},
					{
						key: "primary",
						label: "Primary Contributor",
						sort: "primary",
						renderCell: ({ data }) => data.primary.toString(),
					},
					{
						key: "sortIndex",
						label: "Sort Index",
						sort: "sortIndex",
						renderCell: ({ data }) => data.sortIndex.toString(),
					},
				]}
			/>
		);
	},
};



// WEBPACK FOOTER //
// ./src/panels/articleDetails/article/contributorFragments.tsx